// data/partenaires2025.js
// Partenaires & sponsors de l'édition 2025 (6e édition).
//
// Champs :
//   - lien      : null s'il n'y a pas de site web
//   - categorie : "institutionnel" (collectivités, institutions...) ou
//                 "prive" (commerçants, artisans, entreprises...).
//                 Si absent, le partenaire est considéré comme privé.
export const partenaires2025 = [
  { nom: "Département de l'Anjou", logo: "/assets/partners/2025/Departement_Anjou_cmjn.webp", lien: null, categorie: "institutionnel" },
  { nom: "Brissac Loire Aubance", logo: "/assets/partners/2025/Brissac-Loire-Aubance-Horizontal-RVB-.webp", lien: null, categorie: "institutionnel" },

  { nom: "SUN - Le Son Unique", logo: "/assets/partners/2025/SUN-LOGO-JAUNE.png", lien: "https://lesonunique.com", categorie: "prive" },
  { nom: "Radio Campus Angers", logo: "/assets/partners/2025/1024px-Logo_Radio_Campus_Angers.webp", lien: null, categorie: "prive" },
  { nom: "Akoufen - La Botellerie", logo: "/assets/partners/2025/Akoufen-LaBotellerie_logo1-RVB-web.webp", lien: null, categorie: "prive" },
  { nom: "Bricomarché", logo: "/assets/partners/2025/Bricomarche_logo_2022.svg.webp", lien: null, categorie: "prive" },
  { nom: "1 Brain 2 Fleurs", logo: "/assets/partners/2025/Logo 1 brain 2 fleurs.webp", lien: null, categorie: "prive" },
  { nom: "Montgolfières", logo: "/assets/partners/2025/Logo montgolfières.webp", lien: null, categorie: "prive" },
  { nom: "Fromagerie Rouet", logo: "/assets/partners/2025/Logo-Fromagerie-Rouet-F-Couleur.webp", lien: null, categorie: "prive" },
  { nom: "Ouest Ouvrage", logo: "/assets/partners/2025/Logo_Ouest_Ouvrage.webp", lien: null, categorie: "prive" },
  { nom: "L'Appart Fitness", logo: "/assets/partners/2025/Logo_l_appart_fitness.webp", lien: null, categorie: "prive" },
  { nom: "La Bonne Conduite", logo: "/assets/partners/2025/la_bonne_conduite.webp", lien: null, categorie: "prive" },
  { nom: "Le Moulin de Sarré", logo: "/assets/partners/2025/le_moulin_de_sarre_logo.webp", lien: null, categorie: "prive" },
  { nom: "La Cave Bio", logo: "/assets/partners/2025/logo_la_cave_bio.webp", lien: null, categorie: "prive" },
];

export default partenaires2025;
